<section class="content-header">

    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0 text-dark">Equipment List</h1>
        </div>
  
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </section>
  <section class="content">
    <!-- Default box -->
    <div class="container-fluid">
  
      <div class="card">
  
        <div class="card-body">
  
          <div class="container" *ngIf="isReadMode">
            <!-- <div class="row">
              <div class="col">
                <label> Search </label> <input [(ngModel)]="seachText" class="form-control">
  
              </div>
              <div class="col">
                <label>Select State:</label>
                <ng-select [items]="states" bindLabel="stateName" autofocus bindValue="stateCode"
                  [(ngModel)]="selectedState">
                </ng-select>
  
              </div>
            </div>
  <br>
            <div class="row">
  
              <div class="col"><input type="button" class="btn btn-primary"
                  value="Search" (click)="search()" /> &nbsp;&nbsp;&nbsp;
                  <input type="button" class="btn btn-primary"
                  value="Reset" (click)="reset()" /></div>
                  
            </div> -->
            <div class=" row">
              <div class="col-12">
                <p style="float:right" >
                    
                    <input type="button" (click)="createRow()"  value="Add Equipment"
                        class="btn btn-link">
                </p>
              </div>
  
            </div>
            <div class="row">

              <div class="col-md-12">
                <p style="float:right"><input type="button" class="btn btn-link" (click)="backOption()" class="btn btn-link" value="Back"></p>
              </div>
            </div>
  
            <div class="row">
              <table class="table table-striped table-hover table-bordered">
                <thead>
                  <tr>
                    <th style="font-weight:bold">S. No.</th>
                    <th style="font-weight:bold">Equipment Type</th>
                    <th style="font-weight:bold">Equipment Name</th>
                    <th style="font-weight:bold">Installation Date</th>
                    <th style="font-weight:bold">Least Count</th>
                    <!-- <th style="font-weight:bold">Model</th> -->
                    <th style="font-weight:bold">Accuracy</th>
                    <!-- <th style="font-weight:bold">Action</th> -->
                  </tr>
  
                </thead>
                <tbody>
                  <tr
                    *ngFor="let equipSample of equipRecordData | paginate : {itemsPerPage: 10, currentPage : p}; let i=index">
                    <td>{{ itemsPerPage * (p - 1) + i + 1 }}</td>
                    <td>{{equipSample.equipmentType}}</td>
                    <td>{{equipSample.equipmentName}}</td>
                    <td>{{equipSample.installationDate  | date: 'dd-MM-yyyy'}}</td>
                    <td>{{equipSample.leastCount}}</td>
                    <!-- <td>{{equipSample.model}}</td> -->
                    <td>{{equipSample.accuracy}}</td>
                    <!-- <td>
                      <input type="button" (click)="updateRow(equipSample)" [disabled]="role!='ADMIN'" value="Edit"
                        class="btn btn-primary">
                    </td> -->
                  </tr>
                </tbody>
              </table>
              <pagination-controls (pageChange)="p = $event" class="float-right"></pagination-controls>
            </div>
  
          </div>
  
          <div *ngIf="!isReadMode" style="margin-left: 150px;">
            <div class="row">
              <div class="col-mod-12">
  
  
                    <form [formGroup]="addEquipmentForm" (ngSubmit)="onupdateUserSubmit()">
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Vehicle No. :
                            <select [(ngModel)]="selectedvehicle" style="width:600px" formControlName="vehicleNo"
                            class="form-control" disabled>
                            <option [ngValue]="null" selected disabled>Select vehicle No.</option>
                            <option *ngFor="let userRecord of userRecordData" [ngValue]="userRecord.userId">
                                {{userRecord.userId}}</option>
                        </select>
  
                        </label>
                      </div>
                        <div class="form-group">
                            <label for="gender">Equipment Type:</label>
                            <div>
                              <input id="Chemical" type="radio" value="Chemical" name="equipmentType" formControlName="equipmentType">
                              <label for="chemical">&nbsp;Chemical</label>
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <input id="Microbiological" type="radio" value="Microbiological" name="equipmentType" formControlName="equipmentType">
                              <label for="Microbiological">&nbsp;Microbiological</label>
                           </div>
                  
                           <div>
                             
                           </div>
                              
                            <!-- <div *ngIf="f.gender.touched && f.gender.invalid" class="alert alert-danger">
                                <div *ngIf="f.gender.errors.required">Name is required.</div>
                            </div> -->
                        </div>
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Equipment Name :
                            <select [(ngModel)]="selectedequipmentsCapabilities" style="width:600px" formControlName="equipmentId"
                            class="form-control">
                            <option [ngValue]="null" selected disabled>Select Equipment</option>
                            <option *ngFor="let equipment of equipmentsData" [ngValue]="equipment.equipmentId">
                                {{equipment.equipmentName}}</option>
                        </select>
  
                        </label>
                      </div>
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Installation Date :
                            <input [(ngModel)]="InstallationDate" class="form-control" type="date" formControlName="installationDate">
                          <!-- <div *ngIf="submitted && addEquipmentForm.controls.emailId.errors" class="error">
                            <div *ngIf="addEquipmentForm.controls.emailId.errors.required" style="color:red">Email Id is
                              required</div>
                          </div> -->
                        </label>
                      </div>
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Least Count :
                          <input type="text" style="width:650px" formControlName="leastCount" class="form-control">
                          <!-- <div
                            *ngIf="submitted && addEquipmentForm.controls.mobileNo.errors && addEquipmentForm.controls.mobileNo.invalid"
                            class="error">
                            <div *ngIf="addEquipmentForm.controls.mobileNo.errors.required" style="color:red">Mobile No. is
                              required
                            </div>
                            <div *ngIf="addEquipmentForm.controls.mobileNo.errors.pattern">Please, Enter 10 digit Mobile
                              Number.</div>
                          </div> -->
                        </label>
                      </div>
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Model :
                          <input type="text" style="width:650px" formControlName="model" class="form-control">
                        </label>
                      </div>
                      <div class="form-group">
                        <label style="font-weight:bold">
                            Accuracy :
                          <input type="text" style="width:650px" formControlName="accuracy" class="form-control">
                        </label>
                      </div>
                      <br />
  
                      <div class="form-group" style="text-align: center;"><input type="submit" value="Submit" class="btn btn-primary"
                          [disabled]="!addEquipmentForm.valid">&nbsp;&nbsp;&nbsp;
                          <input type="submit" (click)="showisReadMode()" value="Back"
                          class="btn btn-primary">
                        </div>
                        
                      <div *ngIf="success" class="alert alert-success alert-dismissible fade show" role="alert">
                        <strong>Success!</strong> Your data has been saved successfully.
                        <button (click)="closeAlert()" type="button" class="close" data-dismiss="alert"
                          aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                    </form>
                    
                  </div>
                </div>
              
          </div>
        </div>
      </div>
    </div>
  </section>
  <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">Please Wait. </p>
  </ngx-spinner>
  